import * as React from 'react';
import { useRef, useState } from 'react';
import MainLayout from '../layouts/main-layout/main-layout';
import { graphql, Link } from 'gatsby';
import { Swiper, SwiperSlide } from 'swiper/react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { useForceRender } from '../hooks/force-render';
import Gallery from '../components/gallery/gallery';
import ParsedContent from '../components/parsed-content/parsed-content';
import TagList from '../components/tag-list/tag-list';

import * as styles from '../styles/pages/project.module.scss';

const ProjectPageTemplate = ({ data }) => {
	const forceRender = useForceRender();

	const project = data?.api?.projects[0];

	const [galleryState, setGalleryState] = useState({
		opened: false,
	});
	const prevBtnRef = useRef(null);
	const nextBtnRef = useRef(null);

	return (
		<MainLayout
			seo={{
				title: project?.title,
				description: data?.api?.seo?.siteDescription,
				meta: [
					{
						name: 'og:image',
						content:
							project?.gallery[0]?.file?.childImageSharp?.gatsbyImageData?.images?.fallback?.src ??
							'',
					},
				],
			}}
		>
			<section className={styles.projectInfoSection}>
				<Link to="/realizace" className={styles.goBackLink}>
					<i className="far fa-chevron-left" />
					Zpět na realizace
				</Link>

				<h1>{project?.title}</h1>

				<TagList tags={project?.categories ?? []} />

				<ParsedContent className={styles.description} html={project?.description} />
			</section>

			{project?.gallery?.length > 0 && (
				<React.Fragment>
					<section className={styles.gallerySection}>
						<Swiper
							slidesPerView={1}
							navigation={{
								prevEl: prevBtnRef.current,
								nextEl: nextBtnRef.current,
							}}
							onInit={() => {
								// Needed to correctly link navigation refs
								forceRender();
							}}
							className={styles.gallery}
						>
							{project?.gallery?.map((image, i) => (
								<SwiperSlide
									key={`projectImage${i}`}
									className={styles.slide}
									onClick={() =>
										setGalleryState({
											opened: true,
											slide: i,
										})
									}
								>
									<GatsbyImage
										title={image?.meta?.title}
										alt={image?.meta?.alt ?? ''}
										image={getImage(image?.file)}
									/>
								</SwiperSlide>
							))}
						</Swiper>

						<button ref={prevBtnRef} className={styles.prevBtn}>
							<i className="fal fa-chevron-left" />
						</button>
						<button ref={nextBtnRef} className={styles.nextBtn}>
							<i className="fal fa-chevron-right" />
						</button>
					</section>

					<Gallery state={galleryState} images={project?.gallery ?? []} />
				</React.Fragment>
			)}
		</MainLayout>
	);
};

export const query = graphql`
	query($slugFilter: API_JsonType!) {
		api {
			seo: seoSingleton {
				siteDescription
			}

			projects: projectsCollection(filter: $slugFilter) {
				title
				categories
				description
				gallery {
					path
					meta
					file {
						childImageSharp {
							gatsbyImageData(layout: FULL_WIDTH)
						}
					}
				}
			}
		}
	}
`;

export default ProjectPageTemplate;
